var asf;

(function (asf) {
  /**
   * 输出信息扩展类
   * @author sodaChen
   * Date:2017/2/15
   */
  var ConsolePlus = function () {
    function ConsolePlus() {}

    ConsolePlus.init = function (isPlusMode) {
      if (isPlusMode === void 0) {
        isPlusMode = false;
      }

      this.funList = [];
      this.funPulsList = [];

      this.emptyFun = function () {}; //存放原来的方法


      for (var i = 0; i < this.funNames.length; i++) {
        this.funList.push(console[this.funNames[i]]);
      } //生成新的扩展方法


      for (var i = 0; i < this.funNames.length; i++) {
        this.createPlusFun(this.funList[i], this.funNames[i]);
      }

      this.setConsoleMode(isPlusMode);
    };
    /**
     * 设置日志等级，所有大于等于这个日志级别的输出都可以正常输出，小于的则不能进行输出
     * @param level
     */


    ConsolePlus.setLevel = function (level) {
      this.$level = level;
      this.openConsole();
    };
    /**
     * 设置输出模式
     * @param isPlusMode 是否为扩展模式
     */


    ConsolePlus.setConsoleMode = function (isPlusMode) {
      this.isPlusMode = isPlusMode;
      if (isPlusMode) this.openConsolePlus();else this.openConsole();
    };
    /**
     * 打开日志
     */


    ConsolePlus.openConsole = function () {
      this.closeConsole(); //扩展默认，则调用扩展方法

      if (this.isPlusMode) {
        this.openConsolePlus();
        return;
      }

      for (var i = this.$level; i < this.funNames.length; i++) {
        //还原成最初的方法
        console[this.funNames[i]] = this.funList[i];
      }
    };
    /**
     * 关闭所有的日志输出
     */


    ConsolePlus.closeConsole = function () {
      //设置回最初的方法
      for (var i = 0; i < this.funNames.length; i++) {
        //定义个空方法屏蔽掉
        console[this.funNames[i]] = this.emptyFun;
      }
    };
    /**
     * 开启日志输出的扩展模式
     */


    ConsolePlus.openConsolePlus = function () {
      this.isPlusMode = true; //扩展console的所有方法

      for (var i = this.$level; i < this.funNames.length; i++) {
        console[this.funNames[i]] = this.funPulsList[i];
      }
    };
    /**
     * 关闭日志输出的扩展模式
     */


    ConsolePlus.closeConsolePlus = function () {
      this.isPlusMode = false; //还原成原来的方法

      this.openConsole();
    };
    /**
     * 创建扩展函数
     * @param oldFun 原有的函数
     * @param funName 函数名称
     */


    ConsolePlus.createPlusFun = function (oldFun, funName) {
      var fun = function fun(message) {
        var optionalParams = [];

        for (var _i = 1; _i < arguments.length; _i++) {
          optionalParams[_i - 1] = arguments[_i];
        }

        console.group("[" + funName + "][" + new Date() + "]");
        oldFun.apply(console, arguments);
        console.groupEnd();
      };

      this.funPulsList.push(fun);
    }; // /日志级别

    /** 调试级别，trace函数路径 **/


    ConsolePlus.TRACE = 0;
    /** 普通日志级别 **/

    ConsolePlus.LOG = 1;
    /** 信息日志级别 **/

    ConsolePlus.INFO = 2;
    /** 警告日志级别 **/

    ConsolePlus.WARN = 3;
    /** 错误日志级别 **/

    ConsolePlus.ERROR = 4;
    /** 默认是最初的日志级别，改变这个值。可以改变日志输出的结果 **/

    ConsolePlus.$level = ConsolePlus.LOG;
    /** 需要屏蔽覆盖的方法名 **/

    ConsolePlus.funNames = ["trace", "log", "info", "warn", "error"];
    return ConsolePlus;
  }();

  asf.ConsolePlus = ConsolePlus;
})(asf || (asf = {}));

module.exports = asf;